import LeadFormFields from './LeadFormFields';
import Colors from '../../constants/Colors';
import { useAuthenticate } from '../../contexts/authFlow';
import { useParent } from '../../hooks/useChild';
import useColorScheme from '../../hooks/useColorScheme';
import { InnerContainer } from '../Layout';
import { TextCta, TextBody, TextBodySmall, TextCtaButton } from '../StyledText';
import { TransparentView, View } from '../Themed';

type LeadFormProps = {
  config: {
    source:
      | 'REQUEST_TOUR'
      | 'REQUEST_CUSTOM_CARE'
      | 'COMING_SOON'
      | 'WAITLIST_CITY'
      | 'WAITLIST_LOCATION'
      | 'NO_SEARCH_RESULTS';
    name?: string;
  };
  additionalFields?: Partial<{
    tourTimes: boolean;
    careTimes: boolean;
  }>;
  description?: string;
  wide?: boolean;
};
export default function LeadForm({
  config,
  description,
  wide = false,
}: LeadFormProps) {
  const authenticate = useAuthenticate();
  const parent = useParent();

  return (
    <InnerContainer
      style={{
        alignItems: 'center',
      }}
    >
      {!parent.id && (
        <TextCta style={{ marginBottom: 16 }}>
          <TextCta
            style={{ textDecorationLine: 'underline' }}
            onPress={() => {
              authenticate('LOGIN');
            }}
          >
            Log in
          </TextCta>{' '}
          to auto-fill your details or{' '}
          <TextCta
            style={{ textDecorationLine: 'underline' }}
            onPress={() => {
              authenticate();
            }}
          >
            Sign up
          </TextCta>
        </TextCta>
      )}
      {description ? (
        <TextBody style={{ textAlign: 'center', marginVertical: 40 }}>
          {description}
        </TextBody>
      ) : null}
      {(config.source === 'WAITLIST_CITY' ||
        config.source === 'WAITLIST_LOCATION') && (
        <WaitListInfo config={config} />
      )}
      <TransparentView style={{ marginBottom: 20, width: '100%' }}>
        <LeadFormFields
          wide={wide}
          fieldsConfig={{
            tourTimes: config.source === 'REQUEST_TOUR',
            specificCareTimes:
              config.source === 'REQUEST_CUSTOM_CARE' ||
              config.source === 'REQUEST_TOUR',
          }}
        />
      </TransparentView>
    </InnerContainer>
  );
}

const titlePerSource: Partial<
  Record<LeadFormProps['config']['source'], string>
> = {
  WAITLIST_CITY: 'City',
  WAITLIST_LOCATION: 'Location',
};
function WaitListInfo({ config }: { config: LeadFormProps['config'] }) {
  const theme = useColorScheme();
  return (
    <View
      style={{
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        marginBottom: 20,
      }}
    >
      {titlePerSource[config.source] ? (
        <TextBodySmall>{titlePerSource[config.source]}</TextBodySmall>
      ) : null}
      <TextCtaButton
        style={{
          marginBottom: 20,
          marginTop: 10,
          paddingVertical: 10,
          width: '100%',
          borderBottomWidth: 2,
          borderColor: Colors[theme].lines,
        }}
      >
        {config.name}
      </TextCtaButton>
    </View>
  );
}
